import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1c16cf2c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "viewing-card-image" }
const _hoisted_2 = ["textContent"]

import { toRefs } from 'vue'
    import ImageThumbnails from '@/components/ui/ImageThumbnails.vue'

    
export default /*#__PURE__*/_defineComponent({
  props: {
    images: null,
    text: null
  },
  setup(__props: any) {

const props = __props as { images: string[], text?: string }

    
    const { images, text } = toRefs(props)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(ImageThumbnails, { images: _unref(images) }, null, 8, ["images"]),
    (_unref(text))
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "text",
          textContent: _toDisplayString(_unref(text))
        }, null, 8, _hoisted_2))
      : _createCommentVNode("", true)
  ]))
}
}

})